import useTranslation from 'hooks/useTranslation'

const AddonSection = ({ name }) => {
  const { t } = useTranslation('basket')
  return (
    <div>
      <div className='list__header element__title'>{t('shop')}</div>
      <div className='list__element --big'>
        <div className='element__title'>{name}</div>
      </div>
    </div>
  )
}

export default AddonSection